import * as React from 'react';

import { WithStyles, withStyles, createStyles } from '@material-ui/core';
import { GridCellProps } from '@progress/kendo-react-grid';
import moment from 'moment';

const styles = () =>
  createStyles({
    historyStatus: {
      paddingBottom: '1px',
    },
  });

type Props = WithStyles<typeof styles> & GridCellProps;

const UpdateddateCell = ({ classes, dataItem, rowType }: Props) => {
  if (
    rowType === 'groupHeader' ||
    rowType === 'groupFooter' ||
    rowType !== 'data'
  ) {
    return null;
  }
  const { updatedDate, updatedDateHistory, showHistory } = dataItem;

  const formatDate = (dateString: string) =>
    moment(dateString).format('DD.MM.YYYY HH:mm:ss');

  const statusHistory = !showHistory
    ? formatDate(updatedDate)
    : updatedDateHistory.map((comp: any, index: number) => (
        <div key={index} className={classes.historyStatus}>
          {formatDate(comp)}
        </div>
      ));

  return <td style={{ verticalAlign: 'top' }}>{statusHistory}</td>;
};

export default withStyles(styles)(UpdateddateCell);
